import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { exportSZLTFailed, exportSZLTSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* exportSZLT(action) {
  try {
    const filter = action.payload;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/registries/order-services/export/`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(exportSZLTSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(exportSZLTFailed());
      const data = yield dataResponse.json();
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(exportSZLTFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
